<div class="flex flex-column h-screen">
	<div class="align-self-center mt-auto mb-auto">

		<p-card class="text-center">
			<ng-template pTemplate="header">
				<div class="pt-3">
					<div class="logo-enseigne"></div>
				</div>
			</ng-template>

  	  <h1 class="mt-0">{{title}}</h1>

			@if (access_denied) {
				<div>
					L'accès n'a pas été autorisé
				</div>
			}

			@if (loading) {
				<div>
					<p>Authentification en cours...</p>
					<p-progressSpinner></p-progressSpinner>
				</div>
			}
			@else {
				<div>
					@if (!authorization_code) {
						<button type="button" pButton (click)="getAuthorizationCode()">Connexion</button>
					}
				</div>
			}

			<p>
				<small><a class="secondary-color" href="{{urlFOC}}">
					Retour à Franchise On Cloud
				</a></small>
			</p>
		</p-card>

	</div>
</div>

